




































import { defineComponent } from '@nuxtjs/composition-api';
import { BasePrice, UCSkeletonShimmer } from '@shared/ui/index';

export default defineComponent({
  name: 'UCProductPrice',
  components: { UCSkeletonShimmer, BasePrice },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    price: {
      type: String,
      required: true,
    },
    compareToPrice: {
      type: String,
      default: null,
    },
    isSaleExpired: {
      type: Boolean,
      default: false,
    },
    promotionEndDate: {
      type: Date,
      default: null,
    },

    /* brand-specific extras (all optional) */
    savingsText: {
      type: String,
      default: '',
    },
    installmentsPrice: {
      type: String,
      default: '',
    },
    installmentsProvider: {
      type: String,
      default: 'AFTERPAY',
    },
  },
});
